import {NgModule} from '@angular/core';
import {PreloadAllModules, RouterModule, Routes} from '@angular/router';

const routes: Routes = [
    {
        path: '',
        redirectTo: 'entrance',
        pathMatch: 'full'
    },
    {
        path: 'customer',
        loadChildren: () => import('./views/customer/pages/home/home.module').then(m => m.HomePageModule)
    },
    {
        path: 'business',
        loadChildren: () => import('./views/business/pages/home/home.module').then(m => m.HomePageModule)
    },
    {
        path: 'settings',
        loadChildren: () => import('./views/common/pages/settings/settings.module').then( m => m.SettingsPageModule)
    },
    {
        path: 'reset-password',
        loadChildren: () => import('./views/common/pages/entrance/log-in/reset-password/reset-password.module')
            .then(m => m.ResetPasswordPageModule)
    },
    {
        path: 'registration',
        loadChildren: () => import('./views/common/pages/entrance/registration/registration.module').then(m => m.SignInPageModule)
    },
    {
        path: 'log-in',
        loadChildren: () => import('./views/common/pages/entrance/log-in/log-in.module').then(m => m.LogInPageModule)
    },
    {
        path: 'entrance',
        loadChildren: () => import('./views/common/pages/entrance/entrance.module').then( m => m.EntrancePageModule)
    },
    { path: '**', redirectTo: 'business', pathMatch: 'full' },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule { }
